module.exports = __webpack_public_path__ + "assets/img/28_982.cc56d033.jpg";